import type from "./action-type";
import * as Api from "api/api";
import {searchGoods} from "api/api";

export const init = (payload) => {
    return {
        type: type.INIT,
        payload,
    };
};

export const setKeyword = (payload) => {
    return {
        type: type.SET_KEYWORD,
        payload,
    };
};

export const setGoodsType = (payload) => {
    return {
        type: type.SET_GOODS_TYPE,
        payload
    }
}

export const setGoodsList = (payload) => {
    return {
        type: type.SET_GOODS_LIST,
        payload,
    };
};

export const setTotalNum = (payload) => {
    return {
        type: type.SET_TOTAL_NUM,
        payload,
    };
};

export const setCondition = (payload) => {
    return {
        type: type.SET_CONDITION,
        payload,
    };
};

export const setFromPrice = (payload) => {
    return {
        type: type.SET_FROM_PRICE,
        payload,
    };
};

export const setToPrice = (payload) => {
    return {
        type: type.SET_TO_PRICE,
        payload,
    };
};

// 获取商品列表
export const fetchGoodsList = (
    {
        selfFlag,
        categoryId,
        isNew,
        isHot,
        keyword,
        order,
        sortFiled,
        fromPrice,
        toPrice,
        pageSize,
        pageNum,
        goodsType,
        isSpecialPrice,
    },
    callback
) => {
    return async (f) => {
        try {
            f(setGoodsList([]))
            const {list, totalNum} = await Api.searchGoods({
                selfFlag,
                page: pageNum,
                size: pageSize,
                goodsType,
                keyword,
                isNew,
                isHot,
                order,
                orderBy: sortFiled,
                categoryId,
                fromPrice,
                toPrice,
            });

            f(setGoodsList(list));
            f(setTotalNum(totalNum));

            if (callback) {
                callback();
            }
        } catch (error) {
        }
    };
};

export const setCategoryId = (payload) => {
    return {
        type: type.SET_CATEGORY_ID,
        payload,
    };
};

export const setIsNew = (payload) => {
    return {
        type: type.SET_IS_NEW,
        payload,
    };
};

export const setIsHot = (payload) => {
    return {
        type: type.SET_IS_HOT,
        payload,
    };
};

export const setPageSize = (payload) => {
    return {
        type: type.SET_PAGE_SIZE,
        payload,
    };
};

export const setPageNum = (payload) => {
    return {
        type: type.SET_PAGE_NUM,
        payload,
    };
};

export const setCategoryList = (payload) => {
    return {
        type: type.SET_CATEGORY_LIST,
        payload,
    };
};

export const setSelectedCategoryList = (payload) => {
    return {
        type: type.SET_SELECTED_CATEGORY_LIST,
        payload,
    };
};

export const pushSelectedCategoryList = (payload) => {
    return {
        type: type.PUSH_SELECTED_CATEGORY_LIST,
        payload,
    };
};

export const truncateSelectedCategoryList = (payload) => {
    return {
        type: type.TRUNCATE_SELECTED_CATEGORY_LIST,
        payload,
    };
};

export const fetchCategoryList = () => {
    return async (f) => {
        try {
            const nav = await Api.nav();

            let list = [];

            const {
                list: pddGoodsCategoryList,
                hasSelfCategory,
            } = await Api.pddGoodsCategoryList({
                parentId: 0,
            });
            list.push(...pddGoodsCategoryList);

            if (hasSelfCategory) {
                list = [
                    {
                        id: 0,
                        name: nav?.selfRun,
                        isSelf: true,
                    },
                    ...list,
                ];
            }

            f(setCategoryList(list));
        } catch (error) {
        } finally {
        }
    };
};

export const fetchChildCategoryList = ({
                                           parentId,
                                           parentOptId,
                                           isSelect,
                                           isSelf,
                                       }) => {
    return async (f) => {
        if (parentId === -1) {
            f(fetchCategoryList());
        } else {
            try {
                let list = [];

                if (isSelf) {
                    const {list: goodsCategoryList} = await Api.childGoodsCategoryList({
                        parentId,
                    });
                    list.push(...goodsCategoryList);
                } else {
                    let {
                        list: pddGoodsCategoryList,
                    } = await Api.pddChildGoodsCategoryList({
                        parentId,
                        parentOptId,
                        isSelect,
                    });
                    list.push(...pddGoodsCategoryList);
                }

                f(setCategoryList(list));
            } catch (error) {
            }
        }
    };
};

export const setRecommendKeywordList = (payload) => {
    return {
        type: type.SET_RECOMMEND_KEYWORD_LIST,
        payload,
    };
};

export const fetchRecommendKeywordList = ({keyword}) => {
    return async (f) => {
        try {
            keyword = "笔记本";
            const res = await Api.recommendKeywordList({keyword});
        } catch (error) {
            console.log(error);
        }
    };
};

export const setRecommendList = (payload) => {
    return {
        type: type.SET_RECOMMEND_LIST,
        payload,
    };
};

export const setGuessList = (payload) => {
    return {
        type: type.SET_GUESS_LIST,
        payload,
    };
};

export const fetchRecommendList = () => {
    return async (f) => {
        let {list} = await Api.recommendList({
            pageSize: 13,
            pageNum: 1,
        });

        list = list?.splice(0, 13);

        f(setRecommendList(list));
    };
};

export const fetchGuessList = () => {
    return async (f) => {
        let {list} = await Api.recommendList({
            pageSize: 6,
            pageNum: 1,
        });

        list = list.splice(0, 6);

        f(setGuessList(list));
    };
};
